import axios from "@/axios.js";
import VueCookie from "vue-cookie";
import config from "../../public/config";
import { not } from "vuelidate/lib/validators";
const resourceHost = config.BASE_API_URL;

class HttpRequest {
  static isErrorAlert = false;

  static sendRequest(type, url, param) {
    switch (type) {
    case "get":
      return this.get(url, param);
    case "put":
      return this.put(url, param);
    case "post":
      return this.post(url, param);
    case "delete":
      return this.delete(url, param);
      // case 'patch': return this.patch(url, param);
    default: {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve) => false);
    }
    }
  }

  static get(url, param, notWarn) {
    this.verifyAccessToken();
    url = `${resourceHost}${url}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response);
          resolve(response);
        })
        .catch((err) => {
          if (!notWarn) this.tooManyRequest(err);
          reject(err);
        });
    });
  }

  static put(url, param, notWarn) {
    this.verifyAccessToken();
    url = `${resourceHost}${url}`;
    return new Promise((resolve, reject) => {
      axios
        .put(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response);
          resolve(response);
        })
        .catch((err) => {
          if (!notWarn) this.tooManyRequest(err);
          reject(err);
        });
    });
  }

  static none_token_put(url, param, notWarn) {
    url = `${resourceHost}${url}`;
    return new Promise((resolve, reject) => {
      axios
        .put(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response);
          resolve(response);
        })
        .catch((err) => {
          if (!notWarn) this.tooManyRequest(err);
          reject(err);
        });
    });
  }

  static post(url, param, notWarn) {
    this.verifyAccessToken();
    url = `${resourceHost}${url}`;
    return new Promise((resolve, reject) => {
      axios
        .post(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response);
          resolve(response);
        })
        .catch((err) => {
          if (!notWarn) this.tooManyRequest(err);
          reject(err);
        });
    });
  }

  static none_token_post(url, param, notWarn) {
    url = `${resourceHost}${url}`;
    return new Promise((resolve, reject) => {
      axios
        .post(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response);
          resolve(response);
        })
        .catch((err) => {
          if (!notWarn) this.tooManyRequest(err);
          reject(err);
        });
    });
  }

  static delete(url, param, notWarn) {
    this.verifyAccessToken();
    url = `${resourceHost}${url}`;
    return new Promise((resolve, reject) => {
      axios
        .delete(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response);
          resolve(response);
        })
        .catch((err) => {
          if (!notWarn) this.tooManyRequest(err);
          reject(err);
        });
    });
  }

  /**
   * 서버에서 전송되는 데이터 양을 줄이기 위해서 key 값과 value 값을 분리해서
   * 2개의 배열로 나눠서 전송할 수 있다.
   * 이 경우 분리된 key, value 값을 하나의 오브젝트로 결합하는 역할을 수행한다.
   * @param response
   * @returns {*}
   */
  static combineKeyValueList(response) {
    // 데이터가 존재하지 않으면 처리하지 않는다
    if (typeof response.data === "undefined") {
      return response;
    } else return response.data;

    // eslint-disable-next-line no-unreachable
    const data = response.data;

    // 반환된 데이터가 key, data 두 개의 키를 가진 object 일 경우에만 변환하도록 한다.
    if (Object.keys(data).length === 2 && data.hasOwnProperty("key") && data.hasOwnProperty("data")) {
      const oldKey = data.key;
      const oldData = data.data;
      const newData = [];

      // 한 줄 한 줄 변경한다..
      // 이로 인해서 클라이언트 쪽의 연산량은 늘어났지만 서버와 통신량이 줄어든다
      for (const oldDataRow of oldData) {
        const newDataRow = {};
        const keySize = oldKey.length;
        for (let i = 0; i < keySize; i++) {
          const key = oldKey[i];
          newDataRow[key] = oldDataRow[i];
        }
        newData.push(newDataRow);
      }

      // 변환된 데이터로 교체한다
      response.data = newData;
    }

    return response;
  }

  static verifyAccessToken() {
    try {
      const token = VueCookie.get("token");
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } catch (err) {
      axios.defaults.headers.common["Authorization"] = "";
    }
  }

    /**
   * 토큰 관련 에러 메시지인지 확인
   * @param {string} message 서버에서 온 에러 메시지
   * @returns {boolean} 토큰 관련 에러인지 여부
   */
  static isTokenRelatedError(message) {
    if (!message || typeof message !== 'string') return false;

    const tokenErrorPatterns = [
      'TOKEN_IN_BLACKLIST',
      'TOKEN_EXPIRED',
      'TOKEN_INVALID',
      'INVALID_TOKEN',
      'EXPIRED_TOKEN',
      'BLACKLISTED_TOKEN',
      'JWT_EXPIRED',
      'JWT_INVALID',
      'UNAUTHORIZED_TOKEN',
      'Token has expired',
      'Invalid token',
      'Expired token',
      'Blacklisted token',
      'token_expired',
      'token_invalid',
      'invalid_token',
      'expired_token'
    ];

    return tokenErrorPatterns.some(pattern =>
      message.toUpperCase().includes(pattern.toUpperCase())
    );
  }

  /**
   * SQL 에러 메시지인지 확인
   * @param {string} message 서버에서 온 에러 메시지
   * @returns {boolean} SQL 에러인지 여부
   */
  static isSqlError(message) {
    if (!message || typeof message !== 'string') return false;

    const sqlErrorPatterns = [
      // MySQL/MariaDB 에러들
      'SQLSTATE',
      'MySQL Error',
      'MariaDB Error',
      'Duplicate entry',
      'for key',
      'Integrity constraint violation',
      'Base table or view not found',
      'Column not found',
      'Unknown column',
      'Table already exists',
      'doesn\'t exist',
      'You have an error in your SQL syntax',

      // PostgreSQL 에러들
      'PostgreSQL Error',
      'ERROR: relation',
      'ERROR: column',
      'ERROR: function',
      'does not exist',
      'already exists',
      'violates',
      'constraint',

      // SQLite 에러들
      'SQLite Error',
      'no such table',
      'no such column',
      'syntax error',

      // 일반적인 SQL 관련
      'SQL Error',
      'Database Error',
      'Query Error',
      'SELECT',
      'INSERT',
      'UPDATE',
      'DELETE',
      'FROM',
      'WHERE',
      'JOIN',
      'INNER JOIN',
      'LEFT JOIN',
      'GROUP BY',
      'ORDER BY',
      'HAVING',

      // ORM/Framework 관련
      'Eloquent',
      'QueryException',
      'Connection refused',
      'Access denied for user',
      'Unknown database',
      'Can\'t connect to',
      'Connection timed out',

      // 테이블/컬럼 정보 노출 패턴
      'Table \'',
      'Column \'',
      'Key \'',
      'Index \'',
      'Foreign key',
      'Primary key'
    ];

    return sqlErrorPatterns.some(pattern =>
      message.includes(pattern) || message.toUpperCase().includes(pattern.toUpperCase())
    );
  }

  /**
   * 민감한 시스템 에러 메시지인지 확인
   * @param {string} message 서버에서 온 에러 메시지
   * @returns {boolean} 민감한 시스템 에러인지 여부
   */
  static isSensitiveSystemError(message) {
    if (!message || typeof message !== 'string') return false;

    const sensitiveErrorPatterns = [
      // 파일 시스템 경로 노출
      '/var/',
      '/usr/',
      '/home/',
      '/etc/',
      '/tmp/',
      'C:\\',
      'D:\\',
      '.php',
      '.js',
      '.py',
      '.java',
      '.cs',

      // 스택 트레이스
      'Stack trace',
      'Traceback',
      'at line',
      'in file',
      'on line',
      'Call stack',
      'Exception trace',

      // 환경 변수나 설정 정보
      'API_KEY',
      'SECRET',
      'PASSWORD',
      'TOKEN',
      'DB_HOST',
      'DB_PASSWORD',
      'DB_USERNAME',
      'DATABASE_URL',
      'REDIS_URL',

      // 메모리 주소나 내부 정보
      '0x',
      'Memory',
      'Fatal error',
      'Segmentation fault',
      'Core dump',

      // PHP 관련 에러들
      'Fatal error:',
      'Parse error:',
      'Warning:',
      'Notice:',
      'Undefined variable',
      'Undefined index',
      'Call to undefined',

      // Node.js 관련
      'Error: Cannot find module',
      'ReferenceError:',
      'TypeError:',
      'SyntaxError:',

      // 서버 내부 정보
      'Apache',
      'Nginx',
      'IIS',
      'Tomcat',
      'localhost',
      '127.0.0.1',
      '192.168.',
      '10.0.',
      '172.'
    ];

    return sensitiveErrorPatterns.some(pattern =>
      message.includes(pattern) || message.toUpperCase().includes(pattern.toUpperCase())
    );
  }

  static async tooManyRequest(err) {
    if (this.isErrorAlert) return;
    this.isErrorAlert = true;

    if (err.response.status === 401) {
      const isProfileDropDown = document.getElementById("ProfileDropDown");
      if (!isProfileDropDown) this.isErrorAlert = false;
      else {
        const logout = new CustomEvent("logout");
        window.dispatchEvent(logout);

        setTimeout(() => (this.isErrorAlert = false), 1000);
      }
    } else if (err.response.status === 429) {
      alert("짧은 시간동안 서버에 너무 많은 요청을 하였습니다. \n1분 뒤 다시 시도해주세요.");
      this.isErrorAlert = false;
    } else {
      const isCheckAlertDialog = document.getElementById("checkAlertDialog");
      if (isCheckAlertDialog) return;

      let errMessage = '서버와 통신 중 오류가 발생했습니다';
      let serverMessage = '';

      // 서버에서 온 원본 메시지 추출
      if (typeof err.response.data === 'string') {
        serverMessage = err.response.data;
      } else if (err.response.data && typeof err.response.data.message === 'string') {
        serverMessage = err.response.data.message;
      } else if (err.response.data && typeof err.response.data.error === 'string') {
        serverMessage = err.response.data.error;
      } else if (err.response.data && err.response.data.error && typeof err.response.data.error.message === 'string') {
        serverMessage = err.response.data.error.message;
      } else if (err.response.data && typeof err.response.data === 'object') {
        if (err.response.data.email && Array.isArray(err.response.data.email) && err.response.data.email.length > 0) {
          serverMessage = err.response.data.email[0];
        }
      }

      // 민감한 에러들을 사용자 친화적 메시지로 변환
      if (this.isTokenRelatedError(serverMessage)) {
        errMessage = '로그인이 만료되었습니다. 다시 로그인해주세요.';
      } else if (this.isSqlError(serverMessage)) {
        errMessage = '데이터 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
        console.warn('SQL Error detected and filtered:', serverMessage); // 개발자용 로그
      } else if (this.isSensitiveSystemError(serverMessage)) {
        errMessage = '시스템 오류가 발생했습니다. 관리자에게 문의하세요.';
        console.warn('Sensitive system error detected and filtered:', serverMessage); // 개발자용 로그
      } else if (serverMessage) {
        // 일반적인 에러는 그대로 표시 (하지만 여전히 주의 필요)
        errMessage = serverMessage;
      }

      if (err.response.status === 422) {
        // 토큰 정보가 일치하지 않을 때
      } else if (errMessage === 'This user is not included in the project'
        || errMessage === '대상 프로젝트를 찾을 수 없습니다'
        || errMessage === '프로젝트 권한이 없습니다') {
        // 프로젝트에 참여하지 않았을 경우,
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "오류가 발생했습니다",
            message: "프로젝트 권한이 없습니다",
            cancelFunction: () => {
              window.location.href = "/";
            },
          },
        });
        window.dispatchEvent(customAlert);
        this.isErrorAlert = false;
      } else {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "오류가 발생했습니다",
            message: errMessage,
          },
        });
        window.dispatchEvent(customAlert);
        this.isErrorAlert = false;
      }
    }
  }
}

export default HttpRequest;
